import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const getHashTargetId = (hash: string) => {
  if (!hash) return null;

  try {
    return decodeURIComponent(hash.slice(1));
  } catch {
    return hash.slice(1);
  }
};

/** Keeps client-side route changes aligned with normal browser navigation. */
const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useLayoutEffect(() => {
    const targetId = getHashTargetId(hash);
    const target = targetId ? document.getElementById(targetId) : null;

    if (target) {
      target.scrollIntoView({ block: 'start' });
      return;
    }

    // The site uses smooth scrolling for in-page links. Temporarily override it
    // so a new route is positioned at the top before the page is painted.
    const root = document.documentElement;
    const previousScrollBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo({ top: 0, left: 0 });
    root.style.scrollBehavior = previousScrollBehavior;
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
